/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Managers/AdManager',['Solitaire/MvvmStructure/Service/ManifestService', 'absolute/storagemanager',
        'absolute/musicmanager', 'absolute/audiomanager', 'absolute/gameconfig',
        'Managers/TelemetryManager', 'Managers/BrowserUtils'],
    function (
        ManifestService, StorageManager, MusicManager, AudioManager,
        GameConfig, TelemetryManager, BrowserUtils
    ) {
        "use strict";

        var AdManager = {

            game: null,
            numCompletedLevels: 0,
            soundMuted: GameConfig.getVal("sfxEnabled"),

            musicMuted: false,
            sfxEnabled: false,

            onMSNUnpause: function () {
            },

            onMSNPause: function () {
            },

            onMSNToggleMute: function () {
                var muted = !!AdManager.soundMuted;
                AdManager.soundMuted = !muted;
                MusicManager.setMuted(AdManager.soundMuted);
                AudioManager.setSfxEnabled(!AdManager.soundMuted);
            },

            onMSNAdPlaybackCompleted: function () {
            },
            
            mute: function () {
                if (this.game && this.game.ui) {
                    this.game.ui.showLoadingScreen();
                }

                this.musicMuted = MusicManager.isMuted();
                this.sfxEnabled = AudioManager.sfxEnabled;

                MusicManager.setMuted(true);
                AudioManager.setSfxEnabled(false);
            },

            unMute: function () {
                MusicManager.setMuted(this.musicMuted);
                AudioManager.setSfxEnabled(this.sfxEnabled);

                if (this.game && this.game.ui) {
                    this.game.ui.hideLoadingScreen();
                    this.game.ui.loadingScreen.resetLoadingProgress();
                    this.game.ui.gameScreen.visible = true;

                    if (this.game.solitaire && this.game.solitaire.SupplyView) {
                        if (!this.game.solitaire.SupplyView.dealSoundIsAllowed) {
                            this.game.solitaire.SupplyView.dealSoundIsAllowed = true;
                            this.game.solitaire.DealNewGame(null, false, true);
                        }
                    }
                }                
            },

            initialize: function (game) {
                this.game = game;

                this.musicMuted = MusicManager.isMuted();
                this.sfxEnabled = AudioManager.sfxEnabled;

                // our default zone ad wrapper
                if (window['InitMsnAdWrapper']) {
                    window['InitMsnAdWrapper']();
                }

                if (window['msnAdWrapper']) {
                    window['msnAdWrapper'].onAdPlaybackCompleted = function () {
                        AdManager.onMSNAdPlaybackCompleted();
                        AdManager.unMute();
                    };

                    window['msnAdWrapper'].onReceivingMuteGame = function () {
                        console.info('onReceivingMuteGame');
                        AdManager.onMSNToggleMute();
                    };

                    window['msnAdWrapper'].onReceivingPauseGame = function () {
                        console.info('onReceivingPauseGame');
                        AdManager.setPaused(!AdManager.paused);
                        window['msnAdWrapper'].gamePaused(AdManager.paused ? 1 : 0);
                        AdManager.paused ? AdManager.onMSNPause() : AdManager.onMSNUnpause();
                    };

                    window['msnAdWrapper'].onReceivingPlayAd = function () {
                        AdManager.setPaused(true);
                        AdManager.mute();
                        window['msnAdWrapper'].startAdPlayback();
                    };

                    window['msnAdWrapper'].onQuitGame = function () {
                        console.info('onQuitGame');
                    };

                    window['msnAdWrapper'].readyForComm();
                }

                // Azerion ad wrapper
                if (window['GD_OPTIONS']) {
                    window['GD_OPTIONS'].SDK_GAME_START = function () {
                        AdManager.setPaused(false);
                        AdManager.unMute();
                    };

                    window['GD_OPTIONS'].SDK_GAME_PAUSE = function () {
                        AdManager.setPaused(true);
                        AdManager.mute();
                    };
                }
            },

            gameStarted: function () {
                // Zone Adwrapper ad call
                if (window['msnAdWrapper']) {
                    AdManager.numCompletedLevels++;
                    console.log('GDK: completedLevel ' + AdManager.numCompletedLevels);
                    window['msnAdWrapper'].completedLevel();
                }

                // Azerion ad call
                if (typeof gdsdk !== 'undefined' && gdsdk.showAd !== 'undefined') {
                    gdsdk.showAd();
                }
            },

            setPaused: function (value) {
                AdManager.paused = value;
            },

            tryShowAd: function (callback, isChallenge, ignoreInterval, isDC) {
                callback();
            }

        };

        return AdManager;
    });

